


// const assignmentOwnitMainInfo = "Specialiserad på felsökning och underhåll av företagsnätverkslösningar som omfattar olika nätverkslager och serverteknologier.";
// const assignmentOwnitItem1 = "Tog fram nya felsökningsrutiner för ny IPTV"
// const assignmentOwnitItem2 = "Assisterade med utbildning av nya medarbetare";

const assignmentOwnitItem1 = "Specialized in troubleshooting and maintaining enterprise network solutions across multiple network layers and server technologies.";
const assignmentOwnitItem2 = "Developed new troubleshooting procedures for a new IPTV platform.";
const assignmentOwnitItem3 = "Assisted with onboarding and training new team members.";



const AssignmentOwnit = {
    desc: [
        assignmentOwnitItem1,
        assignmentOwnitItem2,
        assignmentOwnitItem3,
    ],
    skill: ['Cicso', 'Juniper', 'H3C', 'Layer 2/3', 'Routing', 'DHCP', 'DNS', 'TCP/IP', 'VOIP', 'IPTV'],
};

export default AssignmentOwnit;




